<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">用户留存数据报表</h1>
    <el-row :gutter="12" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select style="width: 160px" v-model="channel" placeholder="">
          <el-option
            v-for="(item, itemIndex) in channelsList"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="isPay"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in isPays"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="19" class="user-options">
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="language"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="platform"
          placeholder=""
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="安卓" :value="1"></el-option>
          <el-option label="ios" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="isNew"
          placeholder=""
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="新用户" :value="1"></el-option>
          <el-option label="老用户" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="primary" @click="exportExcel"> 下载 </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        border
        v-loading="login1"
        id="out-table"
      >
        <el-table-column
          prop="query_date"
          fixed
          label="日期"
          width="120"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="0"
          label="人数"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          v-for="(item, index) in 14"
          :key="index + 99"
          :prop="item.toString()"
          :label="item + 1 + '日留存'"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            <div v-if="scope.row[item] !== 0" class="item">
              {{
                scope.row[item] !== 0 ? scope.row[item] + '%' : scope.row[item]
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="29"
          label="30日留存"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            <div v-if="scope.row[29] !== 0" class="item">
              {{ scope.row[29] !== 0 ? scope.row[29] + '%' : scope.row[29] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
import FileSaver from "file-saver";
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      isPay: 0,
      isPays: [
        {
          country: '全部',
          countryCode: 0,
        },
        {
          country: '未付费',
          countryCode: 1,
        },
        {
          country: '付费',
          countryCode: 2,
        },
      ],
      isNew: 0,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      channel: 'all',
      channelsList: this.$store.state.channels,
      country: 'all',
      countryList: [],
      language: 'all',
      languageList: [],
      platform: -1,
      // 分引
      page: 1,
      total: 0,
      // 通话日期
      platformData: [datainfor(7), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      // 表格数据
      dayChatDetailData: [],
    }
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.query_retention,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.channel,
          country: this.country,
          language: this.language,
          isNew: this.isNew,
          isPay: this.isPay,
          platform: this.platform,
          page: this.page,
        },
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.list
      this.dayChatDetailData.map((item) => {
        for (let i = 0; i < 15; i++) {
          if (item[i] == undefined) {
            item[i] = 0
          }
        }
        if (item[29] == undefined) {
          item[29] = 0
        }
      })
      this.total = res.data.totalCount
    },
    exportExcel() {
      //不加判断table表格导出会有两份数据，是因为fixed造成的，所以要筛选去重
      // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
      var fix = document.querySelector('.el-table__fixed')
      var exportTable
      if (fix) {
        exportTable = XLSX.utils.table_to_book(
          document.querySelector('#out-table').removeChild(fix)
        )
        document.querySelector('#out-table').appendChild(fix)
      } else {
        exportTable = XLSX.utils.table_to_book(
          document.querySelector('#out-table')
        )
      }
      var exportTableOut = XLSX.write(exportTable, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      //sheetjs.xlsx为导出表格的标题名称
      try {
        FileSaver.saveAs(
          new Blob([exportTableOut], { type: 'application/octet-stream' }),
          '用户留存数据报表.xlsx'
        )
      } catch (e) {
        throw e
      }
      return exportTableOut
    },

    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
  },
}
</script>

<style lang="stylus" scoped>

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 50px;
    background: rgba(184, 187, 222, 0.8);
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
